// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2XXez","selected":"styles_selected__15kGe"};